export default __webpack_public_path__ + "static/media/hubspot.ab892e1d.svg";